export default __webpack_public_path__ + "static/media/pattern10.3e87533c.png";